export const BU_CONTENT_SIZES = [
  'small',
  'medium',
  'large'
];
